const awards = [
    { id: 1, value: 'Great Place to Work' },
];

export const getCompanyAwards = () => {
    return awards;
};